module.exports = __webpack_public_path__ + "media/images/japan/circle-eb62381dc6f5820a5c6738e5a53a2574.svg";